import ErrorBox from '@components/common/ErrorBox';
import NotifyForm from '@moncler/components/notify/NotifyForm';
import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import formutils from '@utils/formutils';
import React, { useCallback, useEffect, useRef, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useBreakpoint from '@utils/useBreakpoint';
import ProductImage from './ProductImage';
import useInnerHeight from '@common/utils/useInnerHeight';
import SimilarProductCarousel from './SimilarProductCarousel';
import ContactDetailsCore from '../clientService/ContactDetailsCore';
import classNames from 'classnames';
const ProductNotifyMeModal = (props) => {
    var _a, _b, _c;
    const currentBreakpoint = useBreakpoint();
    const currentHeight = useInnerHeight();
    const { t } = useTranslation();
    const [formdef, setFormdef] = useState();
    const [initialValues, setInitialValues] = useState();
    const [requestSent, setRequestSent] = useState();
    const [fullproductid, setFullproductid] = useState();
    const [classHeight, setClassHeight] = useState();
    const [currentSize, setCurrentSize] = useState();
    const [errors, setErrors] = useState([]);
    const { product, color, size } = props;
    const isFullyOutOfStock = useMemo(() => {
        var _a, _b;
        const sizeAttributes = (_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.variationAttributes) === null || _b === void 0 ? void 0 : _b.find((attr) => attr.attributeId === 'size');
        return sizeAttributes === null || sizeAttributes === void 0 ? void 0 : sizeAttributes.values.every((value) => value.ATS <= 0);
    }, [props.product]);
    useEffect(() => {
        setCurrentSize(size);
    }, [size]);
    useEffect(() => {
        var _a, _b;
        if (color && currentSize) {
            setFullproductid(`${(_a = props.product) === null || _a === void 0 ? void 0 : _a.masterId}${(_b = props.color) === null || _b === void 0 ? void 0 : _b.id}${currentSize === null || currentSize === void 0 ? void 0 : currentSize.id}`);
        }
    }, [product, color, currentSize]);
    // non renderizzare la modale all'apertura della pagina, non fare chiamate se non aperta
    const firstRender = useRef(true);
    useEffect(() => {
        if (props.isOpen && firstRender.current) {
            firstRender.current = false;
            let val = {};
            api.getForm('notifyme-product', val, true).then((data) => {
                prefillValues(val);
                setInitialValues(val);
                setFormdef(data);
            });
        }
        if (!props.isOpen && requestSent && !firstRender.current) {
            setRequestSent(null);
        }
    }, [props.isOpen]);
    useEffect(() => {
        if (currentHeight < 730 && currentBreakpoint >= window.mqObj.md) {
            setClassHeight(true);
        }
        else {
            setClassHeight(false);
        }
    }, [currentHeight, currentBreakpoint]);
    const prefillValues = (values) => {
        values.productid = fullproductid;
        values.from = window.location.href; // debug invalid forms
    };
    const validate = async (values) => {
        prefillValues(values);
        return await formutils.validateForm(values, formdef, 'notifyme-product');
    };
    const onSubmit = async (values) => {
        prefillValues(values);
        setErrors([]);
        let err = await validate(values);
        if (err && Object.keys(err).length > 0) {
            return err;
        }
        return api.notifymeSubmit(values, formdef).then((data) => {
            var _a, _b;
            let errors = {};
            if (!formutils.checkValidationAfterSubmit(data, errors)) {
                return errors;
            }
            if (((_a = window.location.pathname) === null || _a === void 0 ? void 0 : _a.includes('wishlist')) || ((_b = window.location.search) === null || _b === void 0 ? void 0 : _b.includes('wishlist')) || props.inWishlist) {
                analytics.wishlistInteractionNotifySubmit(props.product.masterId);
            }
            else {
                analytics.notifyMeSubmit(currentSize.id, props.product.id, props.from);
            }
            setRequestSent(values);
        });
    };
    const thankYou = useCallback(() => {
        return (React.createElement("div", { className: "product-notify__confirm", role: "alert" },
            React.createElement("p", null, t('notifyme.thankyou')),
            React.createElement("p", null, t('notifyme.confirmation')),
            React.createElement(SimilarProductCarousel, { onRequestClose: props.onRequestClose, product: product, labelVisible: true, swiperConf: {
                    slidesPerView: 'auto',
                    breakpoints: {
                        1024: {
                            slidesPerView: 'auto',
                        },
                    },
                } })));
    }, [requestSent]);
    const notifyForm = () => (React.createElement(React.Fragment, null,
        React.createElement(NotifyForm, { product: props.product, color: props.color, formdef: formdef, onSubmit: onSubmit, initialValues: initialValues, currentSize: currentSize, showSizeSelector: !props.product.isParfum && (!props.size || isFullyOutOfStock), setCurrentSize: setCurrentSize, validate: validate, buttonText: t('button.submit') }),
        React.createElement("div", { className: "notifyme-modal-contactus" },
            React.createElement("p", null, t('clientservice.contactsdetails.intro')),
            React.createElement(ContactDetailsCore, { hidePrefix: true, hideCountrySelector: true, type: "LIST" }))));
    const content = useCallback(() => {
        if (requestSent) {
            return thankYou();
        }
        else {
            return notifyForm();
        }
    }, [requestSent, formdef, currentSize, props.color, fullproductid]);
    return (React.createElement(ModalDialog, { hideHeader: true, noPadding: true, isOpen: props.isOpen, onRequestClose: props.onRequestClose, contentLabel: props.title, className: classHeight && 'notifyme-modal-class', id: "notifyme", style: { content: { height: props.fromReserve ? document.querySelector('#reserveinboutique').offsetHeight : undefined } } },
        React.createElement("div", { className: "product-notify" },
            React.createElement("div", { className: classNames('product-notify__main', { 'white-bg': window.enableColorBackgroundStillLife }) },
                React.createElement(ProductImage, { img: (_a = props.product) === null || _a === void 0 ? void 0 : _a.imgs, type: "F" })),
            React.createElement("div", { className: requestSent ? 'product-notify__thankyou' : 'product-notify__detail' },
                React.createElement("div", { className: "modal__header-sticky" },
                    React.createElement("h2", { className: "dialog__title" },
                        props.fromReserve && React.createElement("button", { className: "icon--arrow-left-black", "aria-label": t('button.back'), onClick: () => props.onRequestClose(true) }),
                        props.title),
                    !requestSent && (React.createElement(React.Fragment, null,
                        React.createElement("p", { className: "modal__intro" }, (props.product.isComingSoon == 2 && !props.product.forceSoldOut)
                            ? t('notifyme.comingsoon')
                            : props.from === 'look'
                                ? t('notifyme.look')
                                : t('notifyme.outofstockmessage', { productName: props.product.productName, color: (_b = props.color) === null || _b === void 0 ? void 0 : _b.displayValue, size: (_c = props.size) === null || _c === void 0 ? void 0 : _c.displayValue })),
                        React.createElement("div", { className: "modal__separator" })))),
                content()),
            React.createElement(ErrorBox, { errors: errors }))));
};
export default ProductNotifyMeModal;
